import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  setPrimaryModalContentOf,
  setSecondaryModalContentOf,
  updatePrimaryModalVisibility,
  updateSecondaryModalVisibility
} from 'store/slices/ModalSlice';

export const useResetModals = (type: 'all' | 'primary' | 'secondary' = 'all') => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (type === 'all' || type === 'primary') {
      dispatch(updatePrimaryModalVisibility(false));
      dispatch(setPrimaryModalContentOf(''));
    }

    if (type === 'all' || type === 'secondary') {
      dispatch(updateSecondaryModalVisibility(false));
      dispatch(setSecondaryModalContentOf(''));
    }
  }, [dispatch, type]);
};
